import { render, staticRenderFns } from "./g-drag-block.vue?vue&type=template&id=0df8b38e&scoped=true&"
import script from "./g-drag-block.vue?vue&type=script&setup=true&lang=ts&"
export * from "./g-drag-block.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./g-drag-block.vue?vue&type=style&index=0&id=0df8b38e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df8b38e",
  null
  
)

export default component.exports